"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DASHBOARD_PATH = exports.LOGIN_PATH = void 0;
exports.LOGIN_PATH = '/login';
exports.DASHBOARD_PATH = '/dashboard';
